import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/stores/create")({
  loader: () => ({
    crumb: "Skapa ny butik",
  }),
})
